import { Routes } from '@/routes';

export default {
	'currency.new': () => import('@/modules/currencies/form'),
} as Routes;
